import { PayloadAction } from '@reduxjs/toolkit'
import { call, takeLatest, put } from 'redux-saga/effects'
import axios from 'shared/utils/axios'
import { exportAllCheckin } from './reducer'
import { exportJsonToCsv } from 'shared/utils/tools'
import queryString from 'qs'
import { showSuccess } from '../app/reducer'
import { PaginatedList } from 'shared/types'
import range from 'lodash/range'
import flatMap from 'lodash/flatMap'
import day from 'dayjs'

function* ExportAllCheckin() {
  try {
    const size = 1000
    const first: PaginatedList<any> = yield call(axios.request, {
      url: `/check-in?${queryString.stringify({ page: 0, size, type: 'export' })}`,
    })

    const total = first.count
    let batches = Math.ceil(total / size) - 1
    if (batches < 0) batches = 0

    const fields = ['Member ID', 'Name', 'Contact email', 'Contact number', 'Check-in time', 'Check-out time', 'Date', 'Program Registered']
  	const promises = yield (async function request(page, index, results: any[]): Promise<any> {
  		try {
  			if (page[index] === undefined)
	  			return results

	  		const response = await axios.request({
	        url: `/check-in?${queryString.stringify({ page: index + 1, size, type: 'export' })}`,
	      })

	      return request(page, index + 1, [...results, response])
  		} catch(err) {
  			return results
  		}
  	})(range(0, batches), 0, [first])

  	const results = flatMap(promises, ({ data }) =>
  		data.map((each: any) => ({
  			'Member ID': each.member_id  || 'N/A',
  			'Name': `${each.first_name} ${each.last_name}`,
  			'Contact email': each.email  || 'N/A',
  			'Contact number': each.phone_number  || 'N/A',
  			'Check-in time': day(each.check_in_time).format('hh:mm a'),
  			'Check-out time': each.check_out_time ? day(each.check_out_time).format('hh:mm a') : 'N/A',
  			'Date': day(each.check_in_time).format('MM/DD/YYYY'),
  			'Program Registered': each.programs ? each?.programs.map(({ name }: any) => `\n${name}`) : 'N/A'
  		}))
  	)

  	yield exportJsonToCsv(results, fields, 'Checkin')
    yield put(showSuccess({ message: 'Participants Successfully Exported' }))
  } catch (err) {
    console.error(err)
  }
}

export default function* rootSaga() {
  yield takeLatest(exportAllCheckin.type, ExportAllCheckin)
}
